import React from "react";

// Core Credit, the gold coin mark used wherever Core Credits balance/cost is shown.
export const CoinIcon = ({ className = "w-4 h-4", ...props }) => (
  <img
    src="/connie-coin.png"
    alt="Core Credit"
    data-testid="connie-coin-icon"
    className={`object-contain shrink-0 drop-shadow-[0_1px_2px_rgba(0,0,0,0.35)] ${className}`}
    {...props}
  />
);

export default CoinIcon;
